import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_claim_account_balance_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  employee_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claim_account_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claim_account_code: fromDatatype.VarcharDatatypeInterface;
  account_balance: fromDatatype.NumericDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  show_account_balance_in_ui: boolean;
}

export class bl_aat_claim_account_balance_RowClass implements bl_aat_claim_account_balance_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  employee_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claim_account_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claim_account_code: fromDatatype.VarcharDatatypeInterface;
  account_balance: fromDatatype.NumericDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  show_account_balance_in_ui: boolean;
}
